import type { BuilderItemType, DraftNode } from "../types";

const ANSWER_TYPES: BuilderItemType[] = [
  "Text",
  "Integer",
  "Quantity",
  "Boolean",
  "Date",
  "Choice",
  "Attachment",
  "Url",
];

/** Top level holds only sections; a repeating group cannot nest groups. */
export function allowedChildTypes(parent: DraftNode | undefined): BuilderItemType[] {
  if (!parent) return ["Section"];
  if (parent.kind === "RepeatingGroup") return ["Display", ...ANSWER_TYPES];
  return ["RepeatingGroup", "Display", ...ANSWER_TYPES];
}

export function isAnswerType(type: string): boolean {
  return (ANSWER_TYPES as string[]).includes(type);
}
